<div class="relative">
  <!-- Acknowledge All Confirmation Modal -->
  <div *ngIf="showAcknowledgeAllConfirmation"
    class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50"
    (click)="cancelAcknowledgeAll()">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-md w-full relative" (click)="$event.stopPropagation()">
      <div class="text-center">
        <svg class="mx-auto h-12 w-12 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <h3 class="mt-2 text-lg font-medium text-gray-900">Acknowledge All Errors</h3>
        <p class="mt-2 text-sm text-gray-500">
          Are you sure you want to acknowledge all error logs? This will mark all unacknowledged errors as acknowledged.
        </p>
      </div>
      <div class="mt-6 flex gap-3">
        <button (click)="cancelAcknowledgeAll()"
          [disabled]="isProcessing"
          class="flex-1 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm disabled:opacity-50">
          Cancel
        </button>
        <button (click)="confirmAcknowledgeAll()"
          [disabled]="isProcessing"
          class="flex-1 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm disabled:opacity-50">
          <span *ngIf="!isProcessing">Acknowledge All</span>
          <span *ngIf="isProcessing" class="flex items-center">
            <svg class="animate-spin h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Processing...
          </span>
        </button>
      </div>
    </div>
  </div>

  <!-- Delete Acknowledged Confirmation Modal -->
  <div *ngIf="showDeleteAcknowledgedConfirmation"
    class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50"
    (click)="cancelDeleteAcknowledged()">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-md w-full relative" (click)="$event.stopPropagation()">
      <div class="text-center">
        <svg class="mx-auto h-12 w-12 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
        </svg>
        <h3 class="mt-2 text-lg font-medium text-gray-900">Delete All Acknowledged Errors</h3>
        <p class="mt-2 text-sm text-gray-500">
          Are you sure you want to delete all acknowledged error logs? This action cannot be undone.
        </p>
      </div>
      <div class="mt-6 flex gap-3">
        <button (click)="cancelDeleteAcknowledged()"
          [disabled]="isProcessing"
          class="flex-1 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm disabled:opacity-50">
          Cancel
        </button>
        <button (click)="confirmDeleteAcknowledged()"
          [disabled]="isProcessing"
          class="flex-1 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:text-sm disabled:opacity-50">
          <span *ngIf="!isProcessing">Delete All</span>
          <span *ngIf="isProcessing" class="flex items-center">
            <svg class="animate-spin h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Processing...
          </span>
        </button>
      </div>
    </div>
  </div>

  <div style="position: relative;" (click)="isActionDropdownOpen = false">
    <app-dynamic-grid [gridConfig]="gridConfig" [getDataUrl]="getDataUrl" [sortBy]="'createdAt'" [sortOrder]="'desc'"
      (onToggleShowToastEmitter)="showToast($event)"></app-dynamic-grid>
    <div style="position: absolute; top: 7px; left: 521px; z-index: 5;" (click)="$event.stopPropagation()">
      <div class="relative inline-block text-left">
        <button type="button"
          class="inline-flex justify-between w-36 border border-gray-300 px-2 py-1 bg-white text-sm text-gray-700 hover:bg-gray-50 focus:outline-none rounded"
          (click)="toggleActionDropdown($event)">
          <span class="truncate">Actions</span>
          <svg class="-mr-1 ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M10 12a1 1 0 01-.707-.293l-4-4a1 1 0 111.414-1.414L10 9.586l3.293-3.293a1 1 0 011.414 1.414l-4 4A1 1 0 0110 12z" clip-rule="evenodd" />
          </svg>
        </button>
        <div class="origin-top-right absolute left-0 z-50 top-5 mt-2 w-56 shadow-lg bg-white ring-1 ring-black ring-opacity-5"
          [ngClass]="{ hidden: !isActionDropdownOpen }">
          <div class="py-1">
            <div class="px-4 py-2">
              <label class="inline-flex items-center cursor-pointer">
                <input type="radio" name="action" value="acknowledgeAll" [(ngModel)]="selectedAction"
                  class="form-radio h-4 w-4 text-indigo-600" />
                <span class="ml-2 text-sm text-gray-700">Acknowledge All Errors</span>
              </label>
            </div>
            <div class="px-4 py-2">
              <label class="inline-flex items-center cursor-pointer">
                <input type="radio" name="action" value="deleteAcknowledged" [(ngModel)]="selectedAction"
                  class="form-radio h-4 w-4 text-indigo-600" />
                <span class="ml-2 text-sm text-gray-700">Delete All Acknowledged</span>
              </label>
            </div>
          </div>
          <div *ngIf="selectedAction" class="flex justify-end px-4 py-2 space-x-2 border-t border-gray-200">
            <button (click)="applyAction()"
              class="px-3 py-1 text-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none">
              Apply
            </button>
            <button (click)="cancelAction()"
              class="px-3 py-1 text-sm text-gray-700 hover:bg-gray-100 focus:outline-none">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-toast></app-toast>
</div>
<router-outlet></router-outlet>